const initialState = {
    responseExecutiveGoalList: {},
    responseExecutiveGoalDetail: null,
    responseCreate: null,
    responseUpdate: null,
    loading: false,
    error: null,
};

export default function executiveGoalReducer(state = initialState, action) {
    switch (action.type) {

        // LISTADO

        case 'EXECUTIVE_GOAL_LIST_REQUEST':
            return {
                ...state,
                loading: true,
                error: null,
            };

        case 'EXECUTIVE_GOAL_LIST_RESPONSE':
            return {
                ...state,
                loading: false,
                responseExecutiveGoalList: action.value,
            };

        case 'EXECUTIVE_GOAL_ERROR':
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        // DETALLE

        case 'EXECUTIVE_GOAL_DETAIL_REQUEST':
            return {
                ...state,
                loading: true,
                error: null,
            };

        case 'EXECUTIVE_GOAL_DETAIL_RESPONSE':
            return {
                ...state,
                loading: false,
                responseExecutiveGoalDetail: action.value,
            };

        // CREATE

        case 'EXECUTIVE_GOAL_CREATE_REQUEST':
            return {
                ...state,
                loading: true,
                error: null,
                responseCreate: null,
            };

        case 'EXECUTIVE_GOAL_CREATE_RESPONSE':
            return {
                ...state,
                loading: false,
                responseCreate: action.value,
            };

        case 'EXECUTIVE_GOAL_CREATE_ERROR':
            return {
                ...state,
                loading: false,
                error: action.error,
            };


        // UPDATE

        case 'EXECUTIVE_GOAL_UPDATE_REQUEST':
            return {
                ...state,
                loading: true,
                error: null,
                responseUpdate: null,
            };

        case 'EXECUTIVE_GOAL_UPDATE_RESPONSE':
            return {
                ...state,
                loading: false,
                responseUpdate: action.value,
            };

        case 'EXECUTIVE_GOAL_UPDATE_ERROR':
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        case 'EXECUTIVE_GOAL_CLEAR_STATE':
            return {
                ...state,
                error: null,
                responseCreate: null,
                responseUpdate: null,
            };

        default:
            return state;
    }
}
